// src/pages/ViolationDashboard.jsx
import React from "react";
import { BASE_URL } from "../utils";
import ModuleDashboard from "../components/ModuleDashboard";

export default function ViolationDashboard() {
  return (
    <ModuleDashboard
      moduleKey="VL"
      eyebrow="Violation Workspace"
      title="Violation Dashboard"
      subtitle="Overview of Approved, Rejected, and Processing violation cases"
      sectionTitle="Violations"
      sectionSubtitle="Live data from the Violation system"
      fetchUrl={`${BASE_URL}/api/violations/dashboard-summary`}
      totalLabel="BBLs"
      showWorkingBadge={false}
    />
  );
}
